import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import { formatNumber } from '../../Utils/Money';

const ShowRetentionToInvoice = ({ retention }) => {
    const { importe, tipo_retencion, porcentaje_info, num_fac_ter, id_pago, nota, id_factura_t } = retention;
    const [retentionsName, setRetentionsName] = useState('');

    useEffect(() => {
        getRetentionsType();
    }, [retention])

    const getRetentionsType = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'tipo-retencion/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                searchRetentionName(data);
            })
            .catch((error) => {
                console.log(error)
            })
    };

    const searchRetentionName = (retentions) => {
        if (retentions !== null && retentions !== undefined) {
            let resul = retentions.filter((retention) => retention.id_tipo_retencion === tipo_retencion.toString());
            setRetentionsName(resul[0].tipo_retencion);
        }
    }

    return (
        <Fragment>
            <Card style={{ border: '1px solid #ff0e0e', padding: 0}}>
                <Row style={{ margin: '0.2em 0.2em' }}>
                    <h4><b>RETENCIÓN: ${formatNumber(importe)}</b></h4>
                    <hr style={{ color: '#ff0e0e', margin: '0.05em 0.5em', width: '80%'}}></hr>
                    <span style={{ margin: 0 }}><b>Tipo de Retención:</b> {retentionsName}</span>
                    <span style={{ margin: 0 }}><b>Porcentaje:</b> {porcentaje_info}%</span>
                    <span style={{ margin: 0 }}><b>Nota:</b> {nota}</span>
                </Row>
            </Card>
        </Fragment>
    )
}

export default ShowRetentionToInvoice